// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__gridContainer {
  display: grid;
  grid-template-columns: minmax(100px, auto) 85px 85px 85px;
  align-items: center;
  gap: 0 5px;
  margin-bottom: 10px;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__headerElement {
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__stepTitle {
  font-size: 16px;
  font-weight: bold;
  text-transform: capitalize;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__stepData {
  height: 50px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/Widgets/GlobalStatusWidget/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".gridContainer {\n  display: grid;\n  grid-template-columns: minmax(100px, auto) 85px 85px 85px;\n  align-items: center;\n  gap: 0 5px;\n  margin-bottom: 10px;\n}\n\n.headerElement {\n  width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.stepTitle {\n  font-size: 16px;\n  font-weight: bold;\n  text-transform: capitalize;\n}\n\n.stepData {\n  height: 50px;\n  width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__gridContainer`,
	"headerElement": `app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__headerElement`,
	"stepTitle": `app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__stepTitle`,
	"stepData": `app-pages-Project-ProductionManagement-Dashboards-Widgets-GlobalStatusWidget-___styles__stepData`
};
export default ___CSS_LOADER_EXPORT___;
